import { Directions } from './chunks'

// const directions = [
//   Directions.north,
//   Directions.east,
//   Directions.south,
//   Directions.west,
//   Directions.up,
//   Directions.down,
// ]

export class BehaviorConnections {
  static onBlockPlace(world, ctx, asset, blockState) {
    const { same, solid } = asset.behaviors.connections
    for (const dir of Directions.all) {
      const nLoc = ctx.location[dir.name]
      const nBlock = world.getBlockAtLocation(nLoc)
      if (!nBlock) continue
      if ((same && nBlock.id === asset.id) || (solid && nBlock.asset.solid[dir.opposite.id])) {
        blockState.props[dir.name] = true
      }
    }
    // console.log('props', props)
  }

  // static onBlockBuild(asset, props) {
  // }

  static deriveStateFromNeighbours(world, ctx, blockState) {
    // this is the same as above, do we even need deriveStateFromNeighbours?
    const block = world.getBlockAtLocation(ctx.location)
    const asset = block.asset
    const { same, solid } = asset.behaviors.connections
    for (const dir of Directions.all) {
      const nLoc = ctx.location[dir.name]
      const nBlock = world.getBlockAtLocation(nLoc)
      if (!nBlock) {
        delete blockState.props[dir.name]
        continue
      }
      if ((same && nBlock.id === asset.id) || (solid && nBlock.asset.solid[dir.opposite.id])) {
        blockState.props[dir.name] = true
      } else {
        delete blockState.props[dir.name]
      }
    }

    // const dir = ctx.direction
    // const block = world.getBlockAtLocation(ctx.location)
    // const asset = block.asset
    // const { same, solid } = asset.behaviors.connections
    // const nBlock = world.getBlockAtLocation(ctx.neighbourLocation)
    // if ((same && nBlock.id === asset.id) || (solid && nBlock.asset.solid[dir.opposite.id])) {
    //   state.props[dir.name] = true
    // } else {
    //   delete state.props[dir.name]
    // }
  }
}
